export const LOADER_GIF = 'https://travel.ackoassets.com/images/fe_icons/circular-loader.gif'
